import React, { forwardRef } from 'react'
import styled, { css } from 'styled-components'
import {
  mediaPortrait,
  mediaTabletAndDown,
} from 'uiComponents/constants/customMedia'

const tabletCssMedia = css`
  padding-left: 0;
  width: 50vw;
  height: 66vw;
  max-width: 100%;
`

export const FullScreenImageContainer = styled.div`
  position: relative;
  height: 100vh;
  width: auto;
  background-size: cover;
  background-position: 50% 20%;
  background-repeat: no-repeat;

  @media ${mediaTabletAndDown} {
    ${tabletCssMedia};
  }

  @media ${mediaPortrait} {
    ${tabletCssMedia};
  }
`

interface IProps {
  dataTestId?: string
  src: string
  className?: string
  children?: React.ReactNode
}

const FullScreenHeightImage = forwardRef<HTMLDivElement, IProps>(
  ({ dataTestId, src, className, children }, ref) => {
    return (
      <FullScreenImageContainer
        data-testid={dataTestId ? dataTestId : 'FullScreenImageContainer'}
        ref={ref}
        className={className}
        style={{ backgroundImage: `url(${src})` }}
      >
        {children}
      </FullScreenImageContainer>
    )
  },
)

export default FullScreenHeightImage
